// @flow
import React from 'react';
import FeatureFlag from '../../features/components/FeatureFlag';
import MessagingButton from './MessagingButton';
import { FEATURES } from '../../features/components/constants';

export default function MessagingGuard(props: any) {
    return (
        <FeatureFlag feature={FEATURES.WEB_MESSAGING_V1}>
            <MessagingButton {...props} />
        </FeatureFlag>
    );
}



// WEBPACK FOOTER //
// ./src/v5/messaging/components/MessagingGuard.jsx